import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { RatioOptions } from '@df/ui/atomic/atomic-options';
import { HideUpComponent } from '@df/ui/hide-up/hide-up.component';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { CMS_COMPONENT_CWV_CONFIG, ICmsComponentCwvConfig } from '../../../../config/component.config';

export interface IRecipe extends NICmsContentComponent.IData, ICmsComponentCwvConfig {
    left_tab_title: string;
    right_tab_title: string;
    content_left: IContentSectionLeft[];
    content_right: IContentSectionRight[];
    ratio?: string;
}

export interface IContentSectionLeft {
    subheading?: string;
    copy: string;
}

export interface IContentSectionRight {
    subheading?: string;
    copy: string;
    image?: string;
}

@ICmsComponent<PageComponentRecipeComponent>({
    id: 'recipe',
    name: 'Recipe',
    tags: ['Blog article'],
    fields: [
        <NICmsContentField.IField>{
            key: 'left_tab_title',
            type: NICmsContentField.EFieldType.text,
            title: 'Tab title',
            required: true,
            default: 'Tab left'
        },
        <NICmsContentField.IField>{
            key: 'right_tab_title',
            type: NICmsContentField.EFieldType.text,
            title: 'Tab title',
            required: true,
            default: 'Tab right'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'content_left',
            title: 'Content left',
            itemName: 'Content left',
            itemNameField: 'content_left',
            fields: [
                <NICmsContentField.IField>{
                    key: 'subheading',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Subheading'
                },
                <NICmsContentField.IField>{
                    key: 'copy',
                    type: NICmsContentField.EFieldType.textarea,
                    title: 'Copy',
                    default: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
                    required: true
                }
            ]
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'content_right',
            title: 'Content right',
            itemName: 'Content right',
            itemNameField: 'content_right',
            fields: [
                <NICmsContentField.IField>{
                    key: 'subheading',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Subheading'
                },
                <NICmsContentField.IField>{
                    key: 'copy',
                    type: NICmsContentField.EFieldType.textarea,
                    title: 'Copy',
                    default: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
                    required: true
                },
                <NICmsContentField.IField>{
                    key: 'image',
                    type: NICmsContentField.EFieldType.image,
                    title: 'Image'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'ratio',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Image or video ratio',
                    options: RatioOptions,
                    description: 'Proportions width x height',
                    default: 'ratio-2-1'
                },
                ...CMS_COMPONENT_CWV_CONFIG
            ]
        }
    ]
})
@Component({
    selector: 'page-component-recipe',
    templateUrl: 'recipe.html',
    styleUrl: './recipe.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [CommonModule, DfImageDirective, HideUpComponent, ICmsClientModule, ToggleModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponentRecipeComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IRecipe;
}
